import "./index.css";
import { useMoviesStore } from "../../stores/useMoviesStore";
import { useEffect, useRef, useCallback } from "react";
import { MovieItem } from "../../components/movie-item";
import { NoItemsFound } from "../../components/common/NoItemsFound";
import Loader from "../../components/common/Loader";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";

const TopRatedScreen = () => {
  const { topRatedMovies, fetchTopRatedMovies, hasMoreTopRated, isLoading } =
    useMoviesStore();

  const pageRef = useRef<number>(1);

  const fetchTopRated = useCallback(() => {
    fetchTopRatedMovies({
      page: pageRef.current,
    });
  }, [fetchTopRatedMovies]);

  const loadMoreVideos = useCallback(() => {
    pageRef.current = pageRef.current + 1;
    fetchTopRated();
  }, [fetchTopRated]);

  useEffect(() => {
    pageRef.current = 1;
    fetchTopRated();
  }, [fetchTopRated]);

  const { lastElementRef } = useInfiniteScroll({
    isLoading,
    hasNextPage: hasMoreTopRated,
    onLoadMore: loadMoreVideos,
  });

  return (
    <div className="screen-container">
      {isLoading && topRatedMovies.length === 0 ? (
        <Loader />
      ) : topRatedMovies.length === 0 ? (
        <NoItemsFound text="No movies in Top Rated!" />
      ) : (
        <>
          <div className="grid-container">
            {topRatedMovies.map((item) => (
              <MovieItem key={item.id} movie={item} />
            ))}
          </div>
          {hasMoreTopRated && (
            <div ref={lastElementRef} style={{ height: "20px" }} />
          )}
        </>
      )}
      {isLoading && topRatedMovies.length > 0 && <Loader />}
    </div>
  );
};

export default TopRatedScreen;
